export const getCoefficientByTime = (time: number): number => Math.exp(0.1 * (time / 1000.0));

export const getTimeByCoefficient = (k: number) => 1000.0 * (10.0 * Math.log(k));
